/**
 * KEEP MEMORIZ — km-media-swap.js
 * Swaps FR images/videos → EN when KM_LANG === 'en'
 */
(function () {
  var lang = (window.KM_LANG || 'fr').toLowerCase();
  if (lang === 'fr') return;

  var SWAP = {

    /* ── ACCUEIL — Héros slides ── */
    'album_de_mariage.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/gallery_wedding.webp?v=1774560934',
    'album_anniversaire.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/souffle_les_bougie_EN.webp?v=1774560934',

    /* ── ACCUEIL — 4 cartes événement ── */
    'carte_qr_code_sur_la_table.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/card_on_table_EN.webp?v=1774560934',
    'Qr_code_sur_la_table.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/QR_code_EN_birthday_table.webp?v=1774560934',
    'table_de_baby_shower_decoree.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/table_QR_code_card.webp?v=1774560934',
    'carte_QR_sur_table_noel_2.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/table_QR_code_noel.webp?v=1774560934',

    /* ── ÉVÉNEMENT — "Tout inclus" image droite ── */
    'album_sur_telephone.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/gallery_in_phone.webp?v=1774560934',
    'souffle_les_bougie.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/souffle_les_bougie_EN.webp?v=1774560934',
    'album_baby_shower.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/album_baby_shower_daf966d4-6baa-4617-822e-e97c208951e6.webp?v=1774560934',
    'album_noel.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/gallery_chrismas_EN.webp?v=1774560934',

    /* ── CCM — Vidéo téléphone "En détail" ── */
    '4f142fcf99364a37ae2428a4a14777f1.mp4':
      'https://cdn.shopify.com/videos/c/o/v/34d874c339d045849b0157f1ebd07757.mp4',
    /* ── CCM — Vidéo démo ── */
    '8cf0a2adf19744d0af05aa914e70e0f8.mp4':
      'https://cdn.shopify.com/videos/c/o/v/653f733af40e43f7869bc8995c29e11f.mp4',
    /* NOTE: album_keepMemoriz.webp = PAS de swap (même image FR/EN) */

    /* ── 15 AFFICHES QR CODE (Custom Liquid — CCM, Événements, Produit) ── */
    'carte_QR_code_mariage_2.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/1.jpg?v=1774537611',
    'carte_QR_code_mariage_3.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/2.jpg?v=1774537611',
    'carte_QR_code_mariage_4.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/3.jpg?v=1774537611',
    'carte_QR_code_mariage_5.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/4.jpg?v=1774537611',
    'carte_QR_code_mariage_6.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/5_3353fcfb-2262-43ae-a3b2-550db471953b.jpg?v=1774537611',
    'carte_QR_code_mariage_8.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/6_8d0c3fbe-54c8-4095-9118-64612c3ac3fc.jpg?v=1774537611',
    'carte_QR_code_mariage_9.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/7_e2b501fd-f055-4128-a777-8f24f8fb8bfb.jpg?v=1774537611',
    'carte_QR_code_mariage_1.webp':     'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/8_b0fbee12-86f0-46b3-8933-de7477b896a2.jpg?v=1774537611',
    'carte_QR_code_anniversaire5.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/9_871ebbb1-2f4d-4bbd-8885-2afdaf2382a1.jpg?v=1774537611',
    'carte_QR_code_anniversaire6.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/10_1ceddde2-40da-4209-9bb2-5b8fd0502f14.jpg?v=1774537611',
    'carte_QR_code_anniversaire7.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/11.jpg?v=1774537611',
    'carte_QR_code_anniversaire1.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/12_0f79f0ae-9200-42d3-a397-b94fb82baaac.jpg?v=1774537611',
    'carte_QR_code_anniversaire2.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/13_20b5d100-46bd-4fec-88a0-37cae2bdccde.jpg?v=1774537611',
    'carte_QR_code_anniversaire3.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/14.jpg?v=1774537611',
    'carte_QR_code_anniversaire4.webp': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/15.jpg?v=1774537611',

    /* ── PRODUIT — Vidéos 4 étapes ── */
    '6f566bcd26ad474ea98c6427513b24dc.mp4': 'https://cdn.shopify.com/videos/c/o/v/813b0c36a8c946aeb2c5cb4be443e5f6.mp4',
    '15d8c739f03b4f69a2206676b343edd0.mp4': 'https://cdn.shopify.com/videos/c/o/v/61c7dca92eb446bb92a1da74f7e14174.mp4',
    '6a5e9d1288d94b6286f2474a5d538fc5.mp4': 'https://cdn.shopify.com/videos/c/o/v/e6dae646606f44f9933faff94df764c8.mp4',
    '5d7a0dc4113942b7b64327dae6a59a53.mp4': 'https://cdn.shopify.com/videos/c/o/v/34d874c339d045849b0157f1ebd07757.mp4',

    /* ── PRODUIT — Photos carrousel Shopify ── */
    'Mockup_album_sur_smartphone_laptop.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/Mockup_album_EN_smartphone_laptop.webp?v=1774600063',
    'hf_20260309_091800_33474df2-eb4a-4454-a295-cd57941ebc04.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/QR_on_table.webp?v=1774560934',
    'hf_20260309_133627_e6e248a0-9ad8-40cf-a45c-ba292d3924dd.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/comment_ca_marche.webp?v=1774560934',
    'hf_20260309_121933_6a3d24cd-e6dd-48cf-8a0d-1010fd15cddc.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/gallery_wedding.webp?v=1774560934',
    'hf_20260309_132305_c05cf889-6f90-494a-bbf1-13cfa587ff52.webp':
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/tableau_des_affiches_QR_code.jpg?v=1775310163',

    /* ── PRODUIT — Carte de tables dans le carrousel Shopify (product media avec hash) ── */
    '2_da65bb55-62c7-4c8a-8f82-fe391e86c73e.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/1.jpg?v=1774537611',
    '3_a47d282f-dfd2-44ea-8abb-c4e9e22ae4e8.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/2.jpg?v=1774537611',
    '4_708fbb4f-2c97-48fe-92b6-7e03ae6c992a.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/3.jpg?v=1774537611',
    '5_32bc69a4-a91c-44fd-8fb6-6eab7100f1c5.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/4.jpg?v=1774537611',
    '6_0fdd437c-3bee-42e0-a0b2-0885c25d75fd.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/5_3353fcfb-2262-43ae-a3b2-550db471953b.jpg?v=1774537611',
    '8_39fef825-371f-4a53-be93-70f46b1836af.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/6_8d0c3fbe-54c8-4095-9118-64612c3ac3fc.jpg?v=1774537611',
    '9_9af5a63a-4e35-42c2-8f1f-307af5b39480.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/7_e2b501fd-f055-4128-a777-8f24f8fb8bfb.jpg?v=1774537611',
    '11_4e8c57f9-5e0d-46af-9d5b-de22b61f2878.jpg': 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/8_b0fbee12-86f0-46b3-8933-de7477b896a2.jpg?v=1774537611',
    '12_f46e588c-50c6-4586-83e0-42ec3ec86517.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/9_871ebbb1-2f4d-4bbd-8885-2afdaf2382a1.jpg?v=1774537611',
    '13_efeba522-2020-4fe9-951e-9161b1673a86.jpg':  'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/10_1ceddde2-40da-4209-9bb2-5b8fd0502f14.jpg?v=1774537611'
  };

  function fname(url) {
    return url ? url.split('?')[0].split('/').pop() : '';
  }

  function enUrl(src) {
    if (!src) return null;
    var f = fname(src);
    /* Direct match */
    if (SWAP[f]) return SWAP[f];
    /* Partial match for Shopify hash suffixes */
    for (var k in SWAP) {
      var kBase = k.replace(/\.\w+$/, '');
      if (kBase.length > 8 && f.indexOf(kBase) !== -1) return SWAP[k];
    }
    return null;
  }

  var done = new WeakSet();

  function swap() {
    /* Images — matches both cdn.shopify.com/s/files/ AND /cdn/shop/files/ */
    document.querySelectorAll('img[src*="/files/"]').forEach(function (img) {
      if (done.has(img)) return;
      var n = enUrl(img.getAttribute('src'));
      if (n) { img.setAttribute('src', n); img.removeAttribute('srcset'); done.add(img); }
    });
    /* Videos */
    document.querySelectorAll('video[src]').forEach(function (v) {
      if (done.has(v)) return;
      var n = enUrl(v.getAttribute('src'));
      if (n) { v.setAttribute('src', n); v.load(); done.add(v); }
    });
    document.querySelectorAll('video source[src]').forEach(function (s) {
      if (done.has(s)) return;
      var n = enUrl(s.getAttribute('src'));
      if (n) { s.setAttribute('src', n); var v = s.closest('video'); if (v) v.load(); done.add(s); }
    });
    /* Background images */
    document.querySelectorAll('[style*="url("]').forEach(function (el) {
      if (done.has(el)) return;
      var st = el.getAttribute('style');
      var m = st.match(/url\(['"]?([^'")\s]+)['"]?\)/);
      if (m && m[1]) {
        var n = enUrl(m[1]);
        if (n) { el.setAttribute('style', st.replace(m[1], n)); done.add(el); }
      }
    });
    document.dispatchEvent(new Event('km:swap-done'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swap);
  } else {
    swap();
  }
  setTimeout(swap, 1500);
  setTimeout(swap, 4000);

  new MutationObserver(function (muts) {
    var run = false;
    muts.forEach(function (m) {
      if (m.addedNodes.length || (m.type === 'attributes' && m.attributeName === 'src')) run = true;
    });
    if (run) swap();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });

})();